// Logo spinner component that wraps Spinner with a zap icon and sets brand context
import type { Size } from "@/constants/size"
import { cn } from "@/lib/utils"

import Spinner from "./spinner"
import SVG from "./svg"

const LogoSpinner = ({
  size,
  shouldAnimateFlicker,
  className,
}: {
  size: keyof typeof Size | number
  shouldAnimateFlicker?: boolean
  className?: string
}) => {
  if (typeof size !== "number") {
    switch (size) {
      case "LG":
        size = 100
        break
      case "MD":
        size = 40
        break
      case "SM":
        size = 32
        break
    }
  }

  const scale = size / 90
  return (
    <div className={cn("flex bg-transparent", className)}>
      <Spinner size={size}>
        <div
          className={cn({
            "animate-flicker": shouldAnimateFlicker,
          })}
        >
          <SVG name="zap" scale={scale} />
        </div>
      </Spinner>
    </div>
  )
}

export default LogoSpinner
